import { createContext, ReactNode, useContext, useState } from 'react';

export type PhotoUploadProgress = { completed: number; total: number } | null;

type PhotoUploadProgressContextValue = {
  progress: PhotoUploadProgress;
  setProgress: (progress: PhotoUploadProgress) => void;
};

const PhotoUploadProgressContext = createContext<PhotoUploadProgressContextValue | null>(null);

export const PhotoUploadProgressProvider = ({ children }: { children: ReactNode }) => {
  const [progress, setProgress] = useState<PhotoUploadProgress>(null);
  return (
    <PhotoUploadProgressContext.Provider value={{ progress, setProgress }}>
      {children}
    </PhotoUploadProgressContext.Provider>
  );
};

/** Wherever bulk uploads happen and a reader might want to see them progress. */
export const usePhotoUploadProgress = (): PhotoUploadProgress => useContext(PhotoUploadProgressContext)?.progress ?? null;

/**
 * Reports upload progress to whatever indicator is listening, if anything.
 * A no-op outside a PhotoUploadProgressProvider — useBulkPhotoUploader is
 * shared with the legacy ScanEditor, which mounts no such provider and has
 * no equivalent indicator to report to.
 */
export const usePhotoUploadProgressReporter = (): (progress: PhotoUploadProgress) => void => {
  const context = useContext(PhotoUploadProgressContext);
  return context?.setProgress ?? (() => {});
};
